import React from "react";
import "../programacion/programacion.css";

const FOCUS_RING =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white";

const CodigoConducta: React.FC = () => {
  return (
    <article className="w-full min-h-screen pt-28 md:pt-40 lg:pt-60 flex justify-center lg:px-8 xl:px-16 pb-16">
      <div className="c-decor-hex c-decor-hex--header" aria-hidden="true" />
      <div className="relative z-10 w-full max-w-[1400px] 3xl:max-w-[1920px] px-8">
        <header>
          <h1 className="w-full text-Colors-white font-semibold uppercase text-3xl md:text-4xl leading-7 md:leading-9 mb-6">
            Código de conducta
          </h1>
        </header>

        <section aria-labelledby="acuerdo-heading">
          <h2
            id="acuerdo-heading"
            className="w-full text-Colors-white text-2xl md:text-4xl font-normal leading-7 md:leading-9 mb-4 mt-8"
          >
            Acuerdo
          </h2>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            La organización del{" "}
            <strong className="font-bold">Open Space JAKALA 2026</strong> se
            compromete a ofrecer un entorno seguro, inclusivo y respetuoso para
            todas las personas asistentes, ponentes, facilitadoras y
            colaboradoras.
          </p>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            La participación en el evento, que es{" "}
            <strong className="font-bold">gratuito y abierto a la comunidad,</strong>{" "}
            implica la aceptación y cumplimiento de este{" "}
            <strong className="font-bold">Código de Conducta.</strong>
          </p>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            Queremos que este Open Space sea un espacio donde todas las personas
            se sientan{" "}
            <strong className="font-bold">
              bienvenidas, escuchadas y valoradas,
            </strong>{" "}
            sin distinción, identidad o expresión de género, orientación sexual,
            discapacidad, apariencia física, edad, etnia, religión, nacionalidad
            o cualquier otra condición.
          </p>
        </section>

        <section aria-labelledby="positivo-heading">
          <h2
            id="positivo-heading"
            className="w-full text-Colors-white text-2xl md:text-4xl font-normal leading-7 md:leading-9 mb-4 mt-8"
          >
            Comportamiento positivo esperado
          </h2>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            Pedimos la colaboración activa de todas las personas para construir
            juntas un ambiente de aprendizaje y participación seguro y
            enriquecedor.
          </p>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            Esperamos que todas las personas asistentes:
          </p>
          <ul className="w-full flex flex-col justify-start items-start gap-3 list-disc list-inside marker:text-Colors-light-blue pl-6 mb-3">
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              Usen un{" "}
              <strong className="font-bold">
                lenguaje amable, respetuoso e inclusivo.
              </strong>
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              <strong className="font-bold">Escuchen con atención</strong> y
              valoren diferentes perspectivas y experiencias.
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              <strong className="font-bold">
                Contribuyan de forma constructiva
              </strong>{" "}
              a las conversaciones y dinámicas.
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              <strong className="font-bold">Muestren empatía</strong> y cuidado
              hacia las demás personas.
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              <strong className="font-bold">Sean conscientes del entorno</strong>{" "}
              y actúen si presencian comportamientos inapropiados o situaciones
              de riesgo, informando al equipo organizador.
            </li>
          </ul>
        </section>

        <section aria-labelledby="inaceptable-heading">
          <h2
            id="inaceptable-heading"
            className="w-full text-Colors-white text-2xl md:text-4xl font-normal leading-7 md:leading-9 mb-4 mt-8"
          >
            Comportamientos inaceptables
          </h2>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            No se tolerarán comportamientos que atenten contra la dignidad,
            integridad o seguridad de las personas, incluyendo (pero no
            limitándose a):
          </p>
          <ul className="w-full flex flex-col justify-start items-start gap-3 list-disc list-inside marker:text-Colors-light-blue pl-6 mb-3">
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              Conductas{" "}
              <strong className="font-bold">
                intimidatorias, acosadoras, abusivas o discriminatorias.
              </strong>
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              Comentarios ofensivos, verbales o escritos, sobre género,
              orientación sexual, discapacidad, apariencia, raza, edad, religión
              o ideología.
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              <strong className="font-bold">
                Uso inapropiado de lenguaje o imágenes
              </strong>{" "}
              con connotaciones sexuales, violentas o degradantes.
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              <strong className="font-bold">
                Interrupciones, acoso, grabaciones o fotografías sin
                consentimiento.
              </strong>
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              <strong className="font-bold">Seguimiento no deseado</strong> o
              contacto físico inapropiado.
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              Cualquier forma de{" "}
              <strong className="font-bold">violencia verbal o física,</strong>{" "}
              dentro o fuera del espacio del evento.
            </li>
          </ul>
        </section>

        <section aria-labelledby="consecuencias-heading">
          <h2
            id="consecuencias-heading"
            className="w-full text-Colors-white text-2xl md:text-4xl font-normal leading-7 md:leading-9 mb-4 mt-8"
          >
            Consecuencias
          </h2>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            El equipo organizador podrá tomar las medidas que considere
            necesarias ante cualquier incumplimiento del Código de Conducta, que
            puede incluir:
          </p>
          <ul className="w-full flex flex-col justify-start items-start gap-3 list-disc list-inside marker:text-Colors-light-blue pl-6 mb-3">
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              Advertencia privada o pública.
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              Expulsión inmediata del evento gratuito, sin derecho a volver a
              participar en futuras ediciones.
            </li>
            <li className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed">
              Comunicación a las autoridades competentes si procede.
            </li>
          </ul>
        </section>

        <section aria-labelledby="contacto-heading">
          <h2
            id="contacto-heading"
            className="w-full text-Colors-white text-2xl md:text-4xl font-normal leading-7 md:leading-9 mb-4 mt-8"
          >
            Cómo actuar y a quién contactar
          </h2>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            Si observas una situación peligrosa o una violación de este código —
            aunque te parezca menor — por favor comunícalo lo antes posible al{" "}
            <strong className="font-bold">equipo organizador de JAKALA</strong>.
          </p>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            Durante el evento habrá personas identificadas del equipo a las que
            podrás acudir de forma directa y confidencial.
          </p>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            También puedes contactar por correo electrónico en:{" "}
            <a
              href="mailto:comunicacion@jakala.com"
              className={`text-Colors-light-blue underline ${FOCUS_RING}`}
            >
              comunicacion@jakala.com
            </a>
          </p>
        </section>

        <section aria-labelledby="compromiso-heading">
          <h2
            id="compromiso-heading"
            className="w-full text-Colors-white text-2xl md:text-4xl font-normal leading-7 md:leading-9 mb-4 mt-8"
          >
            Nuestro compromiso
          </h2>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            Desde <strong className="font-bold">JAKALA</strong> creemos que la
            innovación y el aprendizaje florecen en espacios seguros, diversos y
            colaborativos.
          </p>
          <p className="w-full text-Colors-white text-base md:text-xl font-normal leading-relaxed md:leading-normal mb-3">
            Este Código de Conducta refleja nuestro compromiso por crear una
            comunidad donde todas las personas puedan participar, compartir
            ideas y disfrutar de la experiencia con respeto a libertad.
          </p>
        </section>
      </div>
    </article>
  );
};

export default CodigoConducta;
